module.exports = __webpack_public_path__ + "assets/img/u4 (2).0af4d7f5.png";